import { render, staticRenderFns } from "./materials-list.vue?vue&type=template&id=11b60784"
import script from "./materials-list.vue?vue&type=script&lang=js"
export * from "./materials-list.vue?vue&type=script&lang=js"
import style0 from "./materials-list.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports